<template>
    <portal to="modals">
        <transition name="modal" appear>
            <div
                v-if="visible"
                ref="elMask"
                :class="['ModalMask', this.customClass, { '--restored': restored }]"
                :style="{ backgroundColor: backgroundColor }"
                @click.self="close"
                @keyup.esc="close"
            >
                <slot></slot>
            </div>
        </transition>
    </portal>
</template>

<style lang="less" type="text/less">
.ModalMask {
    position: fixed;
    z-index: 1040;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 0.3s ease;
    overflow-x: hidden;
    overflow-y: auto;
    opacity: 1;
    -webkit-overflow-scrolling: touch;

    &.modal-enter-active:not(.--restored) {
        transition: all 0.2s ease;
        opacity: 0;

        &.modal-enter-to {
            opacity: 1;
        }
    }

    &.modal-leave-active {
        transition: all 0.2s ease;
        opacity: 1;

        &.modal-leave-to {
            opacity: 0;
        }
    }
}
</style>

<script type="text/babel">
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [HasSubscriptions, RestoreOnPageBack],
    props: ['closeTrigger', 'closing', 'opacity','customClass'],

    data() {
        return {
            elMask: null,
            restored: null,
            scroll: 0,
            visible: true,
        }
    },

    computed: {
        backgroundColor() {
            return 'rgba(15, 2, 22, ' + this.opacity + ')'
        },
    },

    created() {
        this.restored = NavigationProvider.justRestored()
        this.subscribe(this.closeTrigger, () => (this.visible = false))

        this.subscribe(this.closing, () => {
            this.scroll = this.elMask.scrollTop
            this.saveState()
        })
    },

    mounted() {
        Vue.nextTick(() => {
            this.elMask = this.$refs.elMask
            this.$emit('mount', this.elMask)
            this.restoreScroll()
        })
    },

    methods: {
        close() {
            this.closeTrigger.next()
        },

        getSaveStateConfig() {
            return {
                autoSave: false,
                cacheKey: this.getCacheKey(),
                saveProperties: ['scroll'],
            }
        },

        restoreScroll() {
            this.elMask.scrollTop = this.scroll
        },
    },
}
</script>
